import React from 'react';
import { Tab, withStyles } from '@material-ui/core';

const StyledTab = withStyles((theme) => ({
  root: {
    // border: '1px solid red',
    textTransform: 'none',
    transition: 'ease .3s',
    // color: '#fff',
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(12),
    padding: 0,
    minWidth: 'auto !important',
    '&:not(:first-child)': {
      marginInlineStart: theme.spacing(2)
    }
  },
  selected: {
    opacity: 1,
    fontWeight: 700,
    fontSize: theme.typography.pxToRem(16),
    color: '#000000DE'
  }
}))((props) => <Tab disableRipple {...props} />);

export default StyledTab;
